import {formatToDDMMYYYY, formatToYYYYMMDD, isValidDate} from "@web-libs/util/dates/date";

export type Birthday = Date;

export const createBirthday = (input: string): Birthday => {
    if (!isValidDate(input)) {
        throw new Error('Invalid date format was used for birthday');
    }
    const [day, month, year] = input.split('.');
    return new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
}

export const birthdayToString = (birthday: Birthday): string => {
    return formatToYYYYMMDD(birthday)
}

export const birthdayToStringDDMMYYYY = (birthday: Birthday): string => {
    return formatToDDMMYYYY(birthday)
}
